import { Loader2, Send } from 'lucide-react';
import { Button } from 'components/ui/button';

/** The one send control, shared by the ranked cards and the manual search rows. */
interface ProposeButtonProps {
  label: string;
  /** True while this row's own send is in flight — never while another row's is. */
  sending: boolean;
  disabled: boolean;
  variant?: 'default' | 'outline';
  /** Id of the rendered text saying why it is disabled — a greyed control alone is a defect. */
  describedBy?: string;
  onClick: () => void;
}

const ProposeButton = ({
  label,
  sending,
  disabled,
  variant = 'default',
  describedBy,
  onClick,
}: ProposeButtonProps) => (
  <Button
    type="button"
    size="sm"
    variant={variant}
    disabled={disabled}
    aria-describedby={describedBy}
    onClick={onClick}
  >
    {sending ? (
      <Loader2 className="mr-1.5 h-4 w-4 animate-spin" aria-hidden="true" />
    ) : (
      <Send className="mr-1.5 h-4 w-4" aria-hidden="true" />
    )}
    {label}
  </Button>
);

export default ProposeButton;
